import { useEffect, useState } from "react";
import { Star, ArrowUpRight } from "lucide-react";
import api from "../../lib/api";
import { SectionHeader, Reveal } from "../Reveal";

const DEFAULT_REVIEWS = [
  {
    quote: "Au-delà du professionnalisme, nous avons surtout apprécié le côté humain de Monsieur Agrebi, toujours présent, bienveillant et à l'écoute à chaque étape. On s'est sentis réellement accompagnés du début à la fin.",
    name: "Kelim Zribi",
    context: "Achat à Golf Juan · Avis Google",
  },
  {
    quote: "An exceptional experience working with Mr. Mehdi El Agrebi during the purchase of our home. He consistently went above and beyond his responsibilities, simply because he genuinely cared about helping us.",
    name: "Neha Tripathi",
    context: "Achat d'une résidence · Avis Google",
  },
  {
    quote: "I had the pleasure of working with Kemelia Estate for over a year, and I can confidently say they exceeded my expectations in every way. Exceptional professionalism, expertise, and dedication.",
    name: "Ali Reza",
    context: "Client depuis plus d'un an · Avis Google",
  },
];

const Stars = () => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={15} className="fill-gold text-gold" />
    ))}
  </div>
);

export default function Testimonials() {
  const [REVIEWS, setREVIEWS] = useState(DEFAULT_REVIEWS);
  useEffect(() => {
    api.get("/reviews").then((r) => {
      if (r.data?.length) setREVIEWS(r.data);
    }).catch(() => {});
  }, []);
  return (
    <section data-testid="testimonials-section" className="pb-12 pt-0 lg:pb-20 lg:pt-2">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeader
          eyebrow="Avis clients"
          title="Ils nous ont fait confiance."
          sub="Des avis réels, laissés par nos clients sur Google."
          align="center"
        />
        <div className="mt-8 grid gap-6 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12}>
              <figure
                data-testid={`review-card-${i}`}
                className="flex h-full flex-col rounded-2xl border border-slate-200/80 bg-white p-8 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(12,35,64,0.08)]"
              >
                <Stars />
                <blockquote className="mt-6 flex-1 font-serif text-xl italic leading-relaxed text-azur">
                  « {r.quote} »
                </blockquote>
                <figcaption className="mt-6 border-t border-slate-100 pt-4">
                  <span className="font-medium text-slate-800">— {r.name}</span>
                  <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
                    {r.context}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-14 text-center">
          <div data-testid="google-reviews-badge" className="inline-flex flex-col items-center gap-3 rounded-2xl border border-slate-200/80 bg-white px-10 py-7 shadow-[0_4px_20px_rgba(0,0,0,0.03)]">
            <Stars />
            <p className="font-serif text-lg italic text-azur">
              Nos clients nous évaluent 5 étoiles sur Google
            </p>
            <a
              href="https://www.google.com/search?q=kemelia+estate&rlz=1C1HKFL_frFR1220FR1220&oq=kemelia+estate&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg9MgYIAhBFGD3SAQgxODQ0ajBqNKgCALACAQ&sourceid=chrome&source=chrome.ob&ie=UTF-8#mpd=~14345390199536287473/customers/reviews"
              target="_blank"
              rel="noreferrer"
              data-testid="google-reviews-link"
              className="group mt-1 inline-flex items-center gap-2 rounded-full border border-azur px-6 py-2.5 text-sm font-medium text-azur transition-all duration-300 hover:bg-azur hover:text-sand"
            >
              Voir tous nos avis
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
